import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import MenuGuard from './MenuGuard';
import LoadingSpinner from '../components/LoadingSpinner';
// import { useRolePermissions } from '../hooks/useRolePermissions';
// Lazy load all components consistently
const Home = React.lazy(() => import('../pages/home/presentation/HomePresentation'));
const DashboardContainer = React.lazy(() => import('../pages/dashboard/DashboardContainer'));
const TicketList = React.lazy(() => import('../pages/ticket/TicketList'));
const UserManagement = React.lazy(() => import('../pages/usermanagement/UserManagement'));
const ApiDemo = React.lazy(() => import('../pages/APIDemo/ApiDemo'));
const Unauthorized = React.lazy(() => import('../pages/unauthorized/Unauthorized'));
const InvestigationList = React.lazy(() => import('../pages/investigation-list/InvestigationList'));
const DriveInvestigationList = React.lazy(() => import('../pages/Drive/investigation_list/DriveInvestigationList'));
const ViewDrive = React.lazy(() => import('../pages/Drive/view_drive/ViewDrive'));
const ElektronikonInvestigationList = React.lazy(() => import('../pages/Elektronikon/investigation_list/ElektronikonInvestigationList'));
const EngineeringDashboard = React.lazy(() => import('../pages/engineering-dashboard/EngineeringDashboard'));
const InternalMotorSearch = React.lazy(() => import('../pages/engineering-dashboard/internal-motor-search/internalMotorSearch'));
const AvailableAlternatives = React.lazy(() => import('../pages/engineering-dashboard/internal-motor-search/available-alternatives/AvailableAlternatives'));
const NotFound = React.lazy(() => import('../pages/NotFound'));
const SolutionResults = React.lazy(() => import('../pages/home/results/components/SolutionResults'));
const MotorList = React.lazy(() => import('../pages/motor-list/MotorList'));
const MotorEditPage = React.lazy(() => import('../pages/motor-list/EditAction/MotorEditPage'));
const ComparisonReport = React.lazy(() => import('../pages/engineering-dashboard/internal-motor-search/available-alternatives/comparison-report/ComparisonReport'));
const ApprovalTasks = React.lazy(() => import('../pages/approval-tasks/ApprovalTasks'));
const InvestgationPage = React.lazy(() => import('../pages/approval-tasks/InvestgationPage'));
const ViewInvestigation = React.lazy(() => import('../pages/investigation-list/ViewInvestigation'));
import { ROUTE_CONSTANTS } from 'constants/routeConstant';
const TicketProgress = React.lazy(() => import('../pages/ticket/component/TicketProgress'));
const ExternalInvestigation = React.lazy(() => import('../pages/engineering-dashboard/internal-motor-search/available-alternatives/external-investigation/ExternalInvestigation'));
const ReleaseNotes = React.lazy(() => import('../pages/release-notes/ReleaseNotes'));
const AppRouter: React.FC = () => {
  // TODO: Replace 'Global Admin' with current user's role from auth context
  // const { isLoading } = useRolePermissions(sessionStorage.getItem('accessRole') || '');

  // if (isLoading) {
  //   return <LoadingSpinner />;
  // }

  return (
    <React.Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/apidemo" element={<ApiDemo />} />

        <Route
          path={`/${ROUTE_CONSTANTS.DASHBOARD}`}
          element={
            <ProtectedRoute>
              <MenuGuard menuName="Dashboard">
                <DashboardContainer />
              </MenuGuard>
            </ProtectedRoute>
          }
        />

        <Route
          path={`/${ROUTE_CONSTANTS.USER_MANAGEMENT}`}
          element={
            <ProtectedRoute>
              <MenuGuard menuName="UserManagement">
                <UserManagement />
              </MenuGuard>
            </ProtectedRoute>
          }
        />

        <Route
          path={`/${ROUTE_CONSTANTS.TICKETS}`}
          element={
            <ProtectedRoute>
              <MenuGuard menuName="TicketList">
                <TicketList />
              </MenuGuard>
            </ProtectedRoute>
          }
       />
          <Route
            path={`/${ROUTE_CONSTANTS.TICKET_CHECK}`}
            element={<TicketProgress />}
          />
        
        <Route
          path={`/${ROUTE_CONSTANTS.INVESTIGATION_LIST}`}
          element={
            <ProtectedRoute>
              <MenuGuard menuName="InvestigationList">
                <InvestigationList />
              </MenuGuard>
            </ProtectedRoute>
          }
        >
          <Route path=":oldMotorPn/:id" element={<ViewInvestigation />} />
        </Route>
        <Route
          path={`/${ROUTE_CONSTANTS.DRIVE_INVESTIGATION_LIST}`}
          element={
            <ProtectedRoute>
              <MenuGuard menuName="DriveInvestigationList">
                <DriveInvestigationList />
              </MenuGuard>
            </ProtectedRoute>
          }
        >
          <Route path=":oldDrivePn/:id" element={<ViewDrive />} />
        </Route>
        <Route
          path={`/${ROUTE_CONSTANTS.ELEKTRONIKON_INVESTIGATION_LIST}`}
          element={
            <ProtectedRoute>
              <MenuGuard menuName="ElektronikonInvestigationList">
                <ElektronikonInvestigationList />
              </MenuGuard>
            </ProtectedRoute>
          }
        />
        <Route
          path={`/${ROUTE_CONSTANTS.MOTOR_LIST}`}
          element={
            <ProtectedRoute>
              <MenuGuard menuName="MotorList">
                <Outlet />
              </MenuGuard>
            </ProtectedRoute>
          }
        >
          <Route index element={<MotorList />} />
          <Route path=":acMotorNumber/:id" element={<MotorEditPage />} />
        </Route>
        <Route
          path={`/${ROUTE_CONSTANTS.SOLUTION_RESULTS}`}
          element={
            <ProtectedRoute>
              <MenuGuard menuName="Dashboard">
                <SolutionResults />
              </MenuGuard>
            </ProtectedRoute>
          }
        />
        <Route
          path={`/${ROUTE_CONSTANTS.ENGINEERING_DASHBOARD}`} 
          element={
            <ProtectedRoute>
              <MenuGuard menuName="EngineeringDashboard">
                <EngineeringDashboard />
              </MenuGuard>
            </ProtectedRoute>
          }
        >
          <Route
            path={`${ROUTE_CONSTANTS.INTERNAL_MOTOR_SELECTION}/:investigationTicketId/:oldMotorNumber/:childTicket`}
            element={<InternalMotorSearch />}
          />
          <Route
            path={`${ROUTE_CONSTANTS.AVAILABLE_ALTERNATIVES}/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId`}
            element={<AvailableAlternatives />}
          />
          <Route
            path={`${ROUTE_CONSTANTS.EXTERNAL_INVESTIGATION}/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId`}
            element={<ExternalInvestigation />}
          />
          <Route
            path={`${ROUTE_CONSTANTS.COMPARISON_REPORT}/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId`}
            element={<ComparisonReport />}
          />
          <Route
            path={`/${ROUTE_CONSTANTS.ENGINEERING_DASHBOARD}/${ROUTE_CONSTANTS.EXTERNAL_INVESTIGATION}/${ROUTE_CONSTANTS.COMPARISON_REPORT}/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId`}
            element={<ComparisonReport />}
          />
        </Route>
        <Route
          path={`/${ROUTE_CONSTANTS.APPROVAL_TASKS}`}
          element={
            <ProtectedRoute>
              <MenuGuard menuName="ApprovalTasks">
                <ApprovalTasks />
              </MenuGuard>
            </ProtectedRoute>
          }
        >
          <Route path=":oldMotorPN/:ticketId/:investigationFlowId" element={<InvestgationPage />} />
        </Route>
        <Route
          path={`/${ROUTE_CONSTANTS.RELEASE_NOTES}`}
          element={
            <ProtectedRoute>
              <MenuGuard menuName="ReleaseNotes">
                <ReleaseNotes />
              </MenuGuard>
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
    </React.Suspense>
  );
};

export default AppRouter;
